module.exports = __webpack_public_path__ + "static/media/login.b79b3ece.png";